import { ReactNode } from 'react'

import { Collapse } from 'antd'

interface CollapseProps {
  borderless?: boolean
  panels?: PanelProps[]
  defaultActiveKey?: string | string[] | number | number[]
  activeKey?: Array<string | number> | string | number
  onChange?: (key: string | string[]) => void
  accordion?: boolean
  children?: ReactNode
  className?: string
  ghost?: boolean
  expandIconPosition?: 'start' | 'end'
  expandIcon?: (panelProps: any) => ReactNode
}

export interface PanelProps {
  key: number
  header: string | ReactNode
  content: ReactNode
  extra?: ReactNode
  showArrow?: boolean
  disabled?: boolean
  className?: string
}

const Display = (props: CollapseProps) => {
  const panels =
    props.panels &&
    props.panels
      .sort((panel) => panel.key)
      .map((p: PanelProps) => {
        return (
          <Collapse.Panel key={p.key} {...p}>
            {p.content}
          </Collapse.Panel>
        )
      })
  return props.panels ? (
    <Collapse bordered={!props.borderless} {...props}>
      {panels}
    </Collapse>
  ) : (
    <Collapse bordered={!props.borderless} {...props}>
      {props.children}
    </Collapse>
  )
}

export default Display
